import { InputProps } from "./Input";

const Checkbox = ({ label, registerFct, ...props }: InputProps) => {
  return (
    <div className="flex items-center py-2" style={props.disabled ? { opacity: 0.5 } : {}}>
      <input
        {...props}
        type="checkbox"
        className={props.disabled ? "cursor-not-allowed" : "cursor-pointer"}
        {...(registerFct && registerFct())}
      ></input>
      {/* htmlFor ties the text to the box so clicking the label toggles it
          (only active when the caller supplies an id). */}
      <label
        htmlFor={props.id}
        className={`mx-2 block text-sm text-gray-700 ${
          props.disabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
